import React from 'react';
import { PageTitle } from '../../../common/components/page-title';
import { DocsLayout } from '../../common/components/layout/docs-layout';
import {
	LIST_MODEL,
	LOCATION_MODEL,
	USER_MODEL,
	POST_MODEL,
	COMMENT_MODEL,
	TAG_MODEL,
	USER_MODEL_PREVIEW, POST_MODEL_PREVIEW, POST_MODEL_CREATE, COMMENT_CREATE
} from '../configs/models';
import { RenderMode } from './model';

export const ModelsPage = () => (
	<React.Fragment>
		<PageTitle
			title="Documentation"
			linkHref="/explorer"
			linkTitle="API Explorer"
		/>
		<DocsLayout>
			<h2 className="text-4xl mb-2">Models</h2>

			<h3 className="text-2xl mt-8">List</h3>
			Data structure for all responses that return array of data.<br />
			In case you get single item your will get it directly.<br /><br />

			<RenderMode keys={LIST_MODEL.keys} />

			<h3 className="text-2xl mt-10">User Preview</h3>
			User as a part of list or other data like post/comment.
			<RenderMode keys={USER_MODEL_PREVIEW.keys} />

			<h3 className="text-2xl mt-10">User Full</h3>
			Full user data returned by id.
			<RenderMode keys={USER_MODEL.keys} />

			<h3 className="text-2xl mt-10">Location</h3>
			Using only as a part of full user data.
			<RenderMode keys={LOCATION_MODEL.keys} />


			<h3 className="text-2xl mt-10">Post Create</h3>
			Post data for create request.
			<RenderMode keys={POST_MODEL_CREATE.keys} />

			<h3 className="text-2xl mt-10">Post Preview</h3>
			Post data as a part of list.
			<RenderMode keys={POST_MODEL_PREVIEW.keys} />

			<h3 className="text-2xl mt-10">Post</h3>
			Post data returned by id.
			<RenderMode keys={POST_MODEL.keys} />

			<h3 className="text-2xl mt-10">Comment Create</h3>
			Comment data to create new item.
			<RenderMode keys={COMMENT_CREATE.keys} />

			<h3 className="text-2xl mt-10">Comment</h3>
			<RenderMode keys={COMMENT_MODEL.keys} />

			<h3 className="text-2xl mt-10">Tag</h3>
			Plain type. Array of strings.


		</DocsLayout>
	</React.Fragment>
);
